// The invoices list opens sorted by accounting date (newest first) by default,
// e.g. via the "Invoices" nav link. This isn't a user-chosen filter/sort, so
// it must not, on its own, surface the "Save filter" button.
export const INVOICES_DEFAULT_SORT_BY = 'accountingDate_desc'
